import {
  AnchorButton,
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  InputGroup,
  NumericInput,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { indianRupee, niceDateTime } from "../fns/util";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import cogoToast from "cogo-toast";

class PanelAuths extends React.Component {
  state = {
    collapsed: true,
    amountPaise: 0,
    authType: null,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  renderAddNewAuth = () => {
    return (
      <ControlGroup>
        <Tag intent="primary" large minimal>
          Add Authorization
        </Tag>
        <Tag intent="primary" large minimal>
          Type
        </Tag>
        <SingleSelectWrapper
          items={["Pre-Authorization", "Final Authorization"]}
          selectedItem={this.state.authType}
          onChange={(value) => this.setState({ authType: value })}
          showSelectProp={true}
        />{" "}
        <Tag intent="primary" large minimal>
          Reference
        </Tag>
        <InputGroup
          disabled={!this.state.authType}
          value={this.state.authRef}
          onChange={(event) => {
            this.setState({ authRef: event.target.value });
          }}
        />
        <Tag intent="primary" large minimal>
          Amount
        </Tag>
        <NumericInput
          disabled={!this.state.authType || !this.state.authRef}
          style={{ width: "7em" }}
          rightElement={<Tag minimal>₹</Tag>}
          buttonPosition="none"
          value={this.state.amountPaise / 100}
          onValueChange={(number) => {
            this.setState({ amountPaise: number * 100 });
          }}
        />
        <Button
          icon="add"
          outlined
          onClick={() => {
            if (!this.state.authType) {
              cogoToast.error("Authorization type not selected");
              return;
            }
            if (!this.state.authRef) {
              cogoToast.error("Authorization reference not entered");
              return;
            }
            if (!this.state.amountPaise) {
              cogoToast.error("Amount not entered");
              return;
            }
            this.props.onUpdate({
              panelAuthorizationsHistory: [
                ...this.props.data.panelAuthorizationsHistory,
                {
                  ts: new Date(),
                  typeOfAuthorization: this.state.authType,
                  amountPaise: this.state.amountPaise,
                  authorizationRef: this.state.authRef,
                },
              ],
              totalCashlessAmountPaise: this.state.amountPaise,
            });
            this.setState({
              authType: null,
              amountPaise: 0,
              // authRef: null,
            });
          }}
        />
      </ControlGroup>
    );
  };
  renderPriorAuths = () => {
    let pp = this.props.data.panelAuthorizationsHistory;
    if (!pp || !pp.length) return null;
    return pp.map((each) => {
      return (
        <ControlGroup style={{ marginTop: "5px" }}>
          <Tag large minimal>
            {niceDateTime(each.ts)}
          </Tag>
          <Tag large intent="success" minimal>
            {each.typeOfAuthorization}
          </Tag>
          <Tag large intent="warning">
            {indianRupee(each.amountPaise)}
          </Tag>
          <Tag large minimal>
            Reference: {each.authorizationRef}
          </Tag>
        </ControlGroup>
      );
    });
  };
  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Panel Auths
            </Tag>
            <Tag large minimal>
              Cashless: {indianRupee(this.props.data.totalCashlessAmountPaise)}
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>
        </Collapse>
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Panel Authorizations
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <AnchorButton
                style={{ marginLeft: "5px" }}
                outlined
                target="_blank"
                icon="credit-card"
                href={`https://print.newchart.care/sxPayment/Bill/${this.state._id}`}
              >
                Procedure Bill
              </AnchorButton>
              <AnchorButton
                style={{ marginLeft: "5px" }}
                outlined
                target="_blank"
                icon="credit-card"
                href={`https://print.newchart.care/sxPayment/gstBill/${this.state._id}`}
              >
                Implant Bill
              </AnchorButton>
              <AnchorButton
                style={{ marginLeft: "5px" }}
                outlined
                target="_blank"
                icon="credit-card"
                href={`https://print.newchart.care/sxPayment/finalBill/${this.state._id}`}
              >
                Summary Bill
              </AnchorButton>
            </div>
            <div
              style={
                this.props.canEdit && this.props.data.chosenPanelName !== "Self"
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              <div
                style={
                  this.props.data.panelAuthorizationsHistory.some(
                    (authorization) =>
                      authorization.typeOfAuthorization ===
                      "Final Authorization"
                  )
                    ? {
                        "pointer-events": "none",
                        opacity: 0.5,
                      }
                    : {}
                }
              >
                {this.renderAddNewAuth()}
              </div>

              {this.renderPriorAuths()}
            </div>
            <br />
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(PanelAuths)));
